/* eslint-disable */
import { faPhoneAlt, faChevronDown, faTimes, faCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate, useParams } from 'react-router-dom'
import { useState, useEffect, useRef, Fragment } from 'react'

import MainTitle from '../../components/MainTitle'
import ClientNav from '../../components/ClientNav'
import useAuth from '../../hooks/useAuth'
import moment from 'moment'
import { ImageConfig } from '../../components/ImageConfig'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import Modal from '../../components/Modal'
import ServiceInformation from '../../components/Clinic/ServiceInformation'
import { Combobox, Transition } from '@headlessui/react'
import { use } from 'react'

const GpSession = ({
  clientData = {},
  claimData = {},
  sessionData = {},
}) => {
  const navigate = useNavigate()

  const { clientId, claimId, sessionId } = useParams()
  const { auth, setShowLoader, showLoader, createInfo } = useAuth()

  const axios = useAxiosPrivate()
  const [prescriptionIssued, setPrescriptionIssued] = useState(sessionData?.additional_data?.prescription_issued ?? null)
  const [requiredAction, setRequiredAction] = useState(sessionData?.additional_data?.required_action ?? [])
  const [activeTab, setActiveTab] = useState("patient");
  const referrableServices = claimData?.metadata?.referrable_services ?? []
  const [notes, setNotes] = useState(sessionData?.notes ?? '')
  const [onSemble, setOnSemble] = useState(
    claimData?.metadata?.dependant_details
      ? clientData?.metadata?.dependants_on_semble?.[claimData?.metadata?.dependant_details?.name?.trim().toLowerCase().replace(/\s+/g, '_')] ?? false
      : clientData?.metadata?.on_semble ?? false
  );
  const [modalTitle, setModalTitle] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [modalType, setModalType] = useState('')
  const [completionReasons, setCompletionReasons] = useState([])
  const [selectedCompletionReason, setSelectedCompletionReason] = useState('0')
  const [servicesReferred, setServicesReferred] = useState(sessionData?.additional_data?.services_referred ?? []);
  const [servicesReferredReasons, setServicesReferredReasons] = useState(sessionData?.additional_data?.services_referred_reasons ?? {});
  const completed = sessionData?.confirmation_reason_id || sessionData?.cancelled

  const [referredForSame, setReferredForSame] = useState(sessionData?.additional_data?.referred_for_same ?? null);

  const [infoSectionOpen, setInfoSectionOpen] = useState(false);
  const [infoSectionService, setInfoSectionService] = useState('');

  const requiredActions = [
    { value: 'gp', label: 'NHS GP follow up' },
    { value: 'ed-utc', label: 'ED/UTC' },
    { value: '111', label: '111' },
    { value: 'nfa', label: 'No further action required' },
  ];


  const referredValid = useRef(true)
  const prescriptionValid = useRef(true)
  const requiredActionValid = useRef(true)
  const referredForSameValid = useRef(true)
  const referralReasonsValid = useRef({})

  useEffect(() => {
    if (!completed) {
      getCompletionReasons()
    }
  }, [])

  const resetModal = () => {
    setShowModal(false)
    setModalTitle('')
    setModalType('')
  }

  const flagAsOnSemble = async () => {
    try {
      setShowLoader(true)
      const response = await axios.post(`/clients/gp/flag-as-on-semble/${clientId}`, {dependant: claimData?.metadata?.dependant_details ? true : false, dependant_name: claimData?.metadata?.dependant_details?.name || ''});
      if (response?.data?.error) {
        createInfo('error', 'Failed to flag as on Semble');
        return
      }
      setOnSemble(true)
      createInfo('success', 'Flagged as on Semble')

    } catch (error) {
      console.error(error);
      createInfo('error', 'Failed to flag as on Semble')
    } finally {
      setShowLoader(false)
    }
  }


  const CompleteSessionElement = () => {
    const completeSession = async (e) => {
      e.preventDefault()
      setShowLoader(true)

      try {
        const response = await axios.post(`/sessions/complete-gp-session/${sessionId}`, {
          confirmation_reason_id: 1, //Completed
          notes: notes?.trim(),
          additional_data: {
            services_referred: servicesReferred,
            prescription_issued: prescriptionIssued,
            required_action: requiredAction,
            services_referred_reasons: servicesReferredReasons,
            referred_for_same: referredForSame
          }
        })
        if (!response.data.error) {
          setShowModal(false)
          createInfo('success', 'Session has been completed')

          setTimeout(() => {
            window.location.reload()
          }, 1500)
        }
      } catch (error) {
        console.error('Error completing session:', error)
      } finally {
        setShowLoader(false)
      }
    }

    return (
      <form onSubmit={completeSession}>
        <div className="flex justify-center mb-4 p-2">
          <h3 className="text-lg font-bold text-center">
            Are you sure you want to complete this appointment?
          </h3>
        </div>

        <p className="text-sm text-red-500 italic mb-3 text-center">
          Once completed, you will be unable to make any further changes
          to this appointment.
        </p>

        <div className="flex mt-2 w-full gap-3">
          <button
            type="submit"
            className="btn blue mt-4 w-1/2"
            disabled={showLoader}
          >
            {showLoader ? 'Completing...' : 'Yes, complete'}
          </button>

          <button
            type="button"
            className="btn red mt-4 w-1/2"
            onClick={resetModal}
            disabled={showLoader}
          >
            No, go back
          </button>
        </div>
      </form>
    )
  }


  const CancelSessionElement = () => {
    const cancelSession = async (e) => {
      e.preventDefault()
      setShowLoader(true)

      try {
        const response = await axios.post(`/sessions/complete-gp-session/${sessionId}`, {
          confirmation_reason_id: 2, //Cancelled
          notes: notes?.trim(),
        })
        if (!response.data.error) {
          setShowModal(false)
          createInfo('success', 'Session has been cancelled')

          setTimeout(() => {
            window.location.reload()
          }, 1500)
        }
      } catch (error) {
        console.error('Error cancelling session:', error)
      } finally {
        setShowLoader(false)
      }
    }

    return (
      <form onSubmit={cancelSession}>
        <div className="flex justify-center mb-4 p-2">
          <h3 className="text-lg font-bold text-center">
            Are you sure you want to cancel this appointment?
          </h3>
        </div>

        <p className="text-sm text-red-500 italic mb-3 text-center">
          Once cancelled, this appointment cannot be restored.
        </p>

        <div className="flex mt-2 w-full gap-3">
          <button
            type="submit"
            className="btn red mt-4 w-1/2"
            disabled={showLoader}
          >
            {showLoader ? 'Cancelling...' : 'Yes, cancel appointment'}
          </button>

          <button
            type="button"
            className="btn blue mt-4 w-1/2"
            onClick={resetModal}
            disabled={showLoader}
          >
            No, go back
          </button>
        </div>
      </form>
    )
  }


  const getCompletionReasons = async () => {
    try {
      setShowLoader(true)
      const response = await axios.get(`/completion-reasons/all`)
      if (response.data.result) {
        setCompletionReasons(response.data.result.reasons)
      }
    } catch (error) { }
    setShowLoader(false)
  }

  const completeSessionClicked = () => {

    prescriptionValid.current = prescriptionIssued !== null
    referredValid.current = claimData?.metadata?.dependant_details || servicesReferred?.length > 0;
    requiredActionValid.current = requiredAction?.length > 0;
    referredForSameValid.current = referredForSame !== null;

    let invalidReasonFound = false
    servicesReferred.forEach(service => {
      const valid = service === 'None' || Boolean(servicesReferredReasons[service]?.trim())
      referralReasonsValid.current[service] = valid
      if (!valid) {
        invalidReasonFound = true
      }
    })

    if (
      !referredValid.current ||
      !prescriptionValid.current ||
      !requiredActionValid.current ||
      !referredForSameValid.current ||
      invalidReasonFound
    ) {
      createInfo('error', 'Please ensure all information complete');
      return
    }

    setModalTitle(`Complete Appointment`)
    setModalType('Complete')
    setShowModal(true)
  }

  const DNAClicked = () => {
    setModalTitle(`Mark Appointment as DNA`)
    setModalType('Cancel')
    setShowModal(true)
  }

  const handleRequiredActionChange = (checked, action) => {
    if (checked) {
      requiredActionValid.current = true

      if (action === 'nfa') {
        setRequiredAction(['nfa']);
        return
      }

      setRequiredAction([
        ...requiredAction.filter(a => a !== 'nfa'),
        action,
      ]);
    } else {
      setRequiredAction(
        requiredAction.filter((a) => a !== action)
      );
    }
  }

  const handleServiceReferralChange = (checked, service) => {
    if (checked) {
      referredValid.current = true
      if (service === 'None') {
        setServicesReferred(['None'])
        return
      }
      setServicesReferred([
        ...servicesReferred.filter(s => s !== 'None'),
        service,
      ]);
    } else {
      setServicesReferred(
        servicesReferred.filter((s) => s !== service)
      );
    }
  }


  const openInfoSection = (service) => {
    setInfoSectionOpen(true)
    setInfoSectionService(service)
  }

  const ModalBody = () => {
    switch (modalType) {
      case 'Complete':
        return <CompleteSessionElement />
      case 'Cancel':
        return <CancelSessionElement />
      default:
        return <></>
    }
  }

  return (
    <div>
      {showModal && (
        <Modal title={modalTitle} body={<ModalBody />} show={resetModal} />
      )}
      {/* <MainTitle
        title={`Client: ${clientData.name} (${clientData.reference})`}
        client={clientData}
        claim={claimData}
        child={clientData.child}
      /> */}

      {sessionData.id && (
        <section>
          {!onSemble ? (
            <div className="bg-amber-100 border-l-4 border-amber-500 text-amber-700 p-2 px-4 text-md mb-2 rounded flex justify-between items-center">
              <p className="font-semibold">
                This patient is NOT on Semble
              </p>
              <button
                type="button"
                onClick={() => flagAsOnSemble()}
                className="rounded-lg bg-amber-600 px-4 py-2 text-sm font-semibold text-white hover:bg-amber-700"
              >
                Mark as entered on Semble
              </button>
            </div>
          ) : (
            <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-2 px-4 text-md mb-2 rounded flex justify-between items-center">
              <p className="font-semibold">
                This patient is on Semble
              </p>
            </div>
          )}

          {completed && (
            <>
              {sessionData?.cancelled ? (
                <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-2 px-4 text-md mb-2 rounded flex justify-between items-center">
                  <p className="font-semibold">
                    This session has was marked as DNA
                  </p>
                </div>
              ) : (
                <div className="bg-green-100 border-l-4 border-green-500 text-green-700 p-2 px-4 text-md mb-2 rounded flex justify-between items-center">
                  <p className="font-semibold">
                    This session has been completed
                  </p>
                </div>
              )}
            </>
          )}

          <section className="w-full bg-white rounded-xl shadow-md py-4 px-4 mb-8">
            <h2
              className="font-bold text-lg mb-4"
            >
              {claimData?.external_reference} - {sessionData?.user?.name}
            </h2>


            <div className="mb-5 ml-0.5 border-b border-gray-200">
              <nav className="flex gap-8" aria-label="Details tabs">
                <button
                  type="button"
                  onClick={() => setActiveTab("patient")}
                  className={`border-b-2 px-1 pb-3 text-base font-semibold transition-colors ${activeTab === "patient"
                    ? "border-blue-600 text-blue-700"
                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                    }`}
                >
                  Patient
                </button>

                <button
                  type="button"
                  onClick={() => setActiveTab("session")}
                  className={`border-b-2 px-1 pb-3 text-base font-semibold transition-colors ${activeTab === "session"
                    ? "border-blue-600 text-blue-700"
                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                    }`}
                >
                  Session
                </button>
              </nav>
            </div>

            {activeTab === 'patient' && (
              <>
                <div className="space-y-5">
                  <div className='flex justify-between'>
                    <p className="text-xl font-semibold text-gray-900">
                      Patient Information: {sessionData?.additional_data?.client_name ? sessionData?.additional_data?.client_name : clientData?.name}
                    </p>
                  </div>
                  <div className="grid grid-cols-1 gap-5 md:grid-cols-3 md:items-stretch">
                    {/* Client Address */}
                    <div className="h-full rounded-xl border border-gray-200 bg-gray-50/50 px-5 pt-4 pb-3">
                      <h3 className="mb-3 text-lg font-semibold text-gray-900">
                        Patient Address
                      </h3>

                      <div className="text-base leading-normal text-gray-600">
                        <p className="m-0">
                          {claimData?.metadata?.client_address?.addressLine1}
                        </p>

                        {claimData?.metadata?.client_address?.addressLine2 && (
                          <p className="m-0">
                            {claimData.metadata.client_address.addressLine2}
                          </p>
                        )}

                        <p className="m-0">
                          {claimData?.metadata?.client_address?.city}
                        </p>

                        <p className="m-0">
                          {claimData?.metadata?.client_address?.county}
                        </p>

                        <p className="m-0">
                          {claimData?.metadata?.client_address?.postcode}
                        </p>
                      </div>
                    </div>

                    {/* GP Details */}
                    <div className="h-full rounded-xl border border-gray-200 bg-gray-50/50 px-5 pt-4 pb-3">
                      <h3 className="mb-3 text-lg font-semibold text-gray-900">
                        GP Details
                      </h3>
                      
                      {!claimData?.metadata?.no_gp ? (
                        <div className="text-base leading-normal text-gray-600">
                          <p className="m-0 font-semibold text-gray-900">
                            {claimData?.metadata?.gp_details?.name || "Not provided"}
                          </p>

                          <p className="m-0">
                            {claimData?.metadata?.gp_details?.address}
                          </p>

                          <p className="m-0">
                            {claimData?.metadata?.gp_details?.city}
                          </p>

                          <p className="m-0">
                            {claimData?.metadata?.gp_details?.postcode}
                          </p>

                          {claimData?.metadata?.gp_details?.phone && (
                            <div className="mt-2 flex items-center gap-2">
                              <FontAwesomeIcon
                                icon={faPhoneAlt}
                                className="text-sm"
                              />
                              <p className="m-0">
                                {claimData.metadata.gp_details.phone}
                              </p>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="text-base leading-normal text-gray-600">
                          <p className="m-0 font-semibold text-gray-900">
                            Not registered with a GP
                          </p>
                        </div>
                      )}
                    </div>

                    {/* Additional Information */}
                    <div className="grid h-full grid-rows-2 gap-3">
                      {/* Sex Assigned at Birth */}
                      <div className="rounded-xl border border-gray-200 bg-gray-50/50 p-4">
                        <h3 className="mb-2 text-lg font-semibold text-gray-900">
                          Sex assigned at Birth
                        </h3>

                        <p className="m-0 text-base leading-normal text-gray-600">
                          {(
                            claimData?.metadata?.dependant_details?.sex_at_birth ||
                            claimData?.metadata?.sex_at_birth
                          )
                            ? (
                              claimData?.metadata?.dependant_details?.sex_at_birth ||
                              claimData?.metadata?.sex_at_birth
                            ).charAt(0).toUpperCase() +
                            (
                              claimData?.metadata?.dependant_details?.sex_at_birth ||
                              claimData?.metadata?.sex_at_birth
                            ).slice(1)
                            : "Not provided"}
                        </p>
                      </div>

                      {/* Date of Birth and Child */}
                      <div className="grid min-h-0 grid-cols-2 gap-3">
                        <div className="rounded-xl border border-gray-200 bg-gray-50/50 p-4">
                          <h3 className="mb-2 text-lg font-semibold text-gray-900">
                            Date of Birth
                          </h3>

                          <p className="m-0 text-base leading-normal text-gray-600">
                            {claimData?.metadata?.dependant_details?.date_of_birth ||
                              clientData?.client_details?.date_of_birth
                              ? moment(
                                claimData?.metadata?.dependant_details?.date_of_birth ||
                                clientData?.client_details?.date_of_birth
                              ).format("DD/MM/YYYY")
                              : "Not provided"}
                          </p>
                        </div>

                        <div className="rounded-xl border border-gray-200 bg-gray-50/50 p-4">
                          <h3 className="mb-2 text-lg font-semibold text-gray-900">
                            Under 16
                          </h3>

                          <p className="m-0 text-base leading-normal text-gray-600">
                            {(claimData?.metadata?.dependant_details?.date_of_birth ||
                              clientData?.client_details?.date_of_birth) &&
                              moment().diff(
                                moment(
                                  claimData?.metadata?.dependant_details?.date_of_birth ||
                                  clientData?.client_details?.date_of_birth
                                ),
                                "years"
                              ) < 16
                              ? "Yes"
                              : "No"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
                <div className="flex-1 flex gap-5">
                  <div className="flex-1 rounded-xl border mt-5 border-gray-200 bg-gray-50/50 p-5">
                    <h3 className="mb-3 text-lg font-semibold text-gray-900">
                      Existing Medical Conditions
                    </h3>

                    {claimData?.metadata?.medical_conditions?.length > 0 ? (
                      <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 list-disc pl-5 text-base">
                        {claimData.metadata.medical_conditions.map((condition, index) => (
                          <li key={index}>
                            {condition
                              .replace(/_/g, " ")
                              .replace(/^./, (char) => char.toUpperCase())}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="text-base">None provided</p>
                    )}
                  </div>

                  <div className="flex-1 rounded-xl border mt-5 border-gray-200 bg-gray-50/50 p-5">
                    <h3 className="mb-3 text-lg font-semibold text-gray-900">
                      Referrable Services
                    </h3>

                    {claimData?.metadata?.dependant_details ? (
                      <p>Dependants cannot be referred</p>
                    ) : (
                      <>
                        {claimData?.metadata?.referrable_services?.length > 0 ? (
                          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1 list-disc pl-5 text-base">
                            {claimData.metadata.referrable_services.map((service, index) => (
                              <li key={index}>
                                {service
                                  .replace(/_/g, " ")
                                  .replace(/^./, (char) => char.toUpperCase())}
                              </li>
                            ))}
                          </ul>
                        ) : (
                          <p className="text-base">None provided</p>
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div className="flex-1 flex gap-5 mb-2">
                  <div className="w-full rounded-xl border mt-5 mb-2 border-gray-200 bg-gray-50/50 p-5">
                    <h3 className="mb-3 text-lg font-semibold text-gray-900">
                      Contact Details
                    </h3>
                    {Boolean((claimData?.metadata?.dependant_details && claimData?.metadata?.dependant_details?.dependant_contact_same) || !claimData?.metadata?.dependant_details) ? (
                    <>
                      <p className="whitespace-pre-wrap break-words text-base leading-relaxed">
                        <span className='font-bold'>Phone Number: </span>{clientData?.client_details?.phone_number}
                      </p>
                      <p className="whitespace-pre-wrap break-words text-base leading-relaxed">
                        <span className='font-bold'>Email: </span>{clientData?.email}
                      </p>
                    </> 
                    ) : ( 
                    <>
                      <p className="whitespace-pre-wrap break-words text-base leading-relaxed">
                        <span className='font-bold'>Phone Number: </span>{claimData?.metadata?.dependant_details?.phone_number}
                      </p>
                      <p className="whitespace-pre-wrap break-words text-base leading-relaxed">
                        <span className='font-bold'>Email: </span> {claimData?.metadata?.dependant_details?.email}
                      </p>
                    </>
                    )}
                  </div>
                  {/* Additional Notes - separate full-width section */}
                  <div className="w-full rounded-xl border mt-5 mb-2 border-gray-200 bg-gray-50/50 p-5">
                    <h3 className="mb-3 text-lg font-semibold text-gray-900">
                      Additional Notes
                    </h3>

                    <p className="whitespace-pre-wrap break-words text-base leading-relaxed">
                      {claimData?.metadata?.additional_notes || "None provided"}
                    </p>
                  </div>
                </div>
                  {/* Additional Notes - separate full-width section */}
                  <div className="w-full rounded-xl border mt-5 mb-2 border-gray-200 bg-gray-50/50 p-5">
                    <h3 className="mb-3 text-lg font-semibold text-gray-900">
                      Referred For
                    </h3>

                    <p className="whitespace-pre-wrap break-words text-base leading-relaxed">
                      {claimData?.metadata?.reason_for_referral || "Not provided"}
                    </p>
                  </div>
              </>
            )}
            {activeTab === 'session' && (
              <div className="space-y-6">
                {/* Main Layout: Left 50% / Right 50% */}
                <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-[minmax(0,1fr)_50%]">
                  {/* Left Section: Form Fields + Help Icons */}
                  <div className="min-w-0">
                    <div className="grid grid-cols-[minmax(0,8fr)_minmax(0,1fr)] gap-2 items-start">
                      {/* Form Fields */}
                      <div className="min-w-0 space-y-5">

                        {/* Prescription Issued */}
                        <div className={!prescriptionValid.current ? `space-y-2 rounded-lg shadow-[0_0_0_6px_white,0_0_0_7px_#ef4444]` : ''}>
                          <div className="space-y-2">
                            <p className="text-lg font-semibold text-gray-900">
                              Has a prescription been issued?{" "}
                              <span className="text-red-500">*</span>
                            </p>

                            <div className="flex w-full gap-3">
                              <label
                                className={`flex flex-1 items-center gap-2 rounded-lg border px-4 py-3 text-base shadow-sm transition ${prescriptionIssued === true
                                  ? "cursor-not-allowed border-blue-500 bg-blue-100 text-blue-900 ring-1 ring-blue-500"
                                  : completed
                                    ? "cursor-not-allowed border-gray-200 bg-gray-50 text-gray-500"
                                    : "cursor-pointer border-gray-300 bg-white text-gray-700 hover:border-blue-500 hover:bg-blue-50"
                                  }`}
                              >
                                <input
                                  type="radio"
                                  name="prescriptionIssued"
                                  value="yes"
                                  checked={prescriptionIssued === true}
                                  onChange={() => {
                                    prescriptionValid.current = true;
                                    setPrescriptionIssued(true);
                                  }}
                                  disabled={completed}
                                  className="h-3 w-3 shrink-0 appearance-none rounded-full border border-gray-300 bg-white checked:border-blue-600 checked:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-75" />
                                <span>Yes</span>
                              </label>

                              <label
                                className={`flex flex-1 items-center gap-2 rounded-lg border px-4 py-3 text-base shadow-sm transition ${prescriptionIssued === false
                                  ? "cursor-not-allowed border-blue-500 bg-blue-100 text-blue-900 ring-1 ring-blue-500"
                                  : completed
                                    ? "cursor-not-allowed border-gray-200 bg-gray-50 text-gray-500"
                                    : "cursor-pointer border-gray-300 bg-white text-gray-700 hover:border-blue-500 hover:bg-blue-50"
                                  }`}
                              >
                                <input
                                  type="radio"
                                  name="prescriptionIssued"
                                  value="no"
                                  checked={prescriptionIssued === false}
                                  onChange={() => setPrescriptionIssued(false)}
                                  disabled={completed}
                                  className="h-3 w-3 shrink-0 appearance-none rounded-full border border-gray-300 bg-white checked:border-blue-600 checked:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-75" />
                                <span>No</span>
                              </label>
                            </div>

                            {!prescriptionValid.current && (
                              <p className="text-xs text-red-500">
                                Please select whether a prescription has been issued.
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Further Action Options */}
                        <div className={!requiredActionValid.current ? `space-y-2 rounded-lg shadow-[0_0_0_6px_white,0_0_0_7px_#ef4444]` : ''}>
                          <div className="space-y-2">
                            <p className="text-lg font-semibold text-gray-900">
                              Patient requires the following{" "}
                              <span className="text-red-500">*</span>
                            </p>

                            <div className="flex w-full flex-col gap-3">
                              {requiredActions.map((action, index) => {
                                const isSelected = requiredAction?.includes(action.value);

                                return (
                                  <label
                                    key={index}
                                    htmlFor={"requiredAction" + index}
                                    className={`flex w-full items-center justify-between gap-3 rounded-lg border px-4 py-3 text-base shadow-sm transition ${isSelected
                                      ? "cursor-not-allowed border-blue-500 bg-blue-100 text-blue-900 ring-1 ring-blue-500"
                                      : completed
                                        ? "cursor-not-allowed border-gray-200 bg-gray-50 text-gray-400 opacity-75"
                                        : "cursor-pointer border-gray-300 bg-white text-gray-700 hover:border-blue-500 hover:bg-blue-50"
                                      }`}
                                  >
                                    <span>{action.label}</span>

                                    <input
                                      id={"requiredAction" + index}
                                      type="checkbox"
                                      checked={isSelected}
                                      onChange={(e) =>
                                        handleRequiredActionChange(e.target.checked, action.value)
                                      }
                                      disabled={completed}
                                      className="h-4 w-4 shrink-0 appearance-none rounded border border-gray-300 bg-white
                                      checked:border-blue-600 checked:bg-blue-600
                                        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1
                                        disabled:cursor-not-allowed disabled:opacity-75"
                                    />
                                  </label>
                                );
                              })}
                            </div>
                            {!requiredActionValid.current && (
                              <p className="text-xs text-red-500">
                                Please select what action was required
                              </p>
                            )}
                          </div>
                        </div>


                        {/* Patient Would Benefit From */}
                        {!claimData?.metadata?.dependant_details ? (
                          <div className={!referredValid.current ? `space-y-2 rounded-lg shadow-[0_0_0_6px_white,0_0_0_7px_#ef4444]` : ''}>
                            <div className="space-y-2">
                              <p className="text-lg font-semibold text-gray-900">
                                Patient would benefit from{" "}
                                <span className="text-red-500">*</span>
                              </p>

                              <div className="flex w-full flex-col gap-3">
                                {referrableServices.concat("None").map((service, index) => {
                                  const isSelected = servicesReferred?.includes(service);
                                  const hasInfo = service !== "None";

                                  return (
                                    <div key={index} className="relative w-full">
                                      {/* Service box: same full width as the required-action boxes */}
                                      <label
                                        htmlFor={"checkbox" + index}
                                        className={`flex w-full items-center justify-between gap-3 rounded-lg border px-4 py-3 text-base shadow-sm transition ${isSelected
                                            ? "cursor-not-allowed border-blue-500 bg-blue-100 text-blue-900 ring-1 ring-blue-500"
                                            : completed
                                              ? "cursor-not-allowed border-gray-200 bg-gray-50 text-gray-500"
                                              : "cursor-pointer border-gray-300 bg-white text-gray-700 hover:border-blue-500 hover:bg-blue-50"
                                          }`}
                                      >
                                        <span>{service}</span>

                                        <input
                                          id={"checkbox" + index}
                                          type="checkbox"
                                          checked={isSelected}
                                          onChange={(e) =>
                                            handleServiceReferralChange(e.target.checked, service)
                                          }
                                          disabled={completed}
                                          className="h-4 w-4 shrink-0 appearance-none rounded border border-gray-300 bg-white checked:border-blue-600 checked:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-75"
                                        />
                                      </label>
                                      {isSelected && service !== 'None' && (
                                        <>
                                          <textarea
                                            rows={1}
                                            placeholder="Reason for referral..."
                                            onChange={(e) => {
                                              if (e.target.value?.trim()) {
                                                referralReasonsValid.current[service] = true
                                              } else {
                                                referralReasonsValid.current[service] = false
                                              }
                                              setServicesReferredReasons({
                                                ...servicesReferredReasons,
                                                [service]: e.target.value
                                              })
                                            }}
                                            value={servicesReferredReasons[service]}

                                            className={`mt-2 w-full resize-y rounded-lg border bg-white px-4 py-2 text-base text-gray-700 shadow-sm transition placeholder:text-gray-400 focus:outline-none focus:ring-2 ${referralReasonsValid.current[service] === false
                                              ? "border-red-500 focus:border-red-500 border-2 focus:ring-red-100"
                                              : "border-gray-300 focus:border-blue-500 focus:ring-blue-100"
                                              }`}
                                          />
                                          {referralReasonsValid.current[service] === false && (
                                            <p className="text-xs text-red-500">
                                              Please enter a reason for {service.toLowerCase()} referral
                                            </p>
                                          )}
                                        </>
                                      )}

                                      {/* Icon sits outside the box without affecting its width or layout */}
                                      {hasInfo && (
                                        <button
                                          type="button"
                                          title={`More information about ${service}`}
                                          aria-label={`More information about ${service}`}
                                          className="absolute left-full top-1/2 ml-3 flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-full border border-gray-300 bg-white text-sm font-semibold text-gray-600 hover:border-blue-500 hover:bg-blue-50 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-100"
                                          onClick={() => openInfoSection(service)}
                                        >
                                          <span className='ml-[0.75px]'>?</span>
                                        </button>
                                      )}
                                    </div>
                                  );
                                })}
                              </div>
                              {!referredValid.current && (
                                <p className="text-xs text-red-500">
                                  Please select what services were referred
                                </p>
                              )}
                            </div>
                          </div>
                        ) : (
                          <div className={!referredValid.current ? `space-y-2 rounded-lg shadow-[0_0_0_6px_white,0_0_0_7px_#ef4444]` : ''}>
                            <div className="space-y-2">
                              <p className="text-lg font-semibold text-gray-900">
                                Patient would benefit from{" "}
                              </p>
                              <div className="bg-amber-100 border-l-4 border-amber-500 text-amber-700 p-2 px-4 text-md rounded flex justify-between items-center">
                                <p>Dependants cannot be referred</p>  
                              </div>
                            </div>
                          </div>
                        )}

                        <div className={!referredForSameValid.current ? `space-y-2 rounded-lg shadow-[0_0_0_6px_white,0_0_0_7px_#ef4444]` : ''}>
                          <div className="space-y-2">
                            <p className="text-lg font-semibold text-gray-900">
                              Was the reason for referral the same as below?{" "}
                              <span className="text-red-500">*</span>
                            </p>

                            <p className='font-medium'>
                              Initial reason: {claimData?.metadata?.reason_for_referral ?? 'N/A'}
                            </p>
                            <div className="flex w-full gap-3">
                              <label
                                className={`flex flex-1 items-center gap-2 rounded-lg border px-4 py-3 text-base shadow-sm transition ${referredForSame === true
                                  ? "cursor-not-allowed border-blue-500 bg-blue-100 text-blue-900 ring-1 ring-blue-500"
                                  : completed
                                    ? "cursor-not-allowed border-gray-200 bg-gray-50 text-gray-500"
                                    : "cursor-pointer border-gray-300 bg-white text-gray-700 hover:border-blue-500 hover:bg-blue-50"
                                  }`}
                              >
                                <input
                                  type="radio"
                                  name="reasonSame"
                                  value="yes"
                                  checked={referredForSame === true}
                                  onChange={() => {
                                    referredForSameValid.current = true;
                                    setReferredForSame(true);
                                  }}
                                  disabled={completed}
                                  className="h-3 w-3 shrink-0 appearance-none rounded-full border border-gray-300 bg-white checked:border-blue-600 checked:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-75" />
                                <span>Yes</span>
                              </label>

                              <label
                                className={`flex flex-1 items-center gap-2 rounded-lg border px-4 py-3 text-base shadow-sm transition ${referredForSame === false
                                  ? "cursor-not-allowed border-blue-500 bg-blue-100 text-blue-900 ring-1 ring-blue-500"
                                  : completed
                                    ? "cursor-not-allowed border-gray-200 bg-gray-50 text-gray-500"
                                    : "cursor-pointer border-gray-300 bg-white text-gray-700 hover:border-blue-500 hover:bg-blue-50"
                                  }`}
                              >
                                <input
                                  type="radio"
                                  name="reasonSame"
                                  value="no"
                                  checked={referredForSame === false}
                                  onChange={() => setReferredForSame(false)}
                                  disabled={completed}
                                  className="h-3 w-3 shrink-0 appearance-none rounded-full border border-gray-300 bg-white checked:border-blue-600 checked:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-75" />
                                <span>No</span>
                              </label>
                            </div>

                            {!referredForSameValid.current && (
                              <p className="text-xs text-red-500">
                                Please select whether a prescription has been issued.
                              </p>
                            )}
                          </div>
                        </div>

                        {/* Notes */}
                        <div className="space-y-2">
                          <label
                            htmlFor="notes"
                            className="block text-lg font-semibold text-gray-900"
                          >
                            Any additional information
                          </label>

                          <textarea
                            id="notes"
                            name="notes"
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            ref={(el) => {
                              if (el) {
                                el.style.height = "auto";
                                el.style.height = `${el.scrollHeight}px`;
                              }
                            }}
                            rows={5}
                            placeholder={!completed ? "Enter any additional information here..." : "None provided"}
                            disabled={completed}
                            className={`w-full ${completed ? "resize-none" : "resize-y"} overflow-hidden rounded-lg border px-4 py-3 text-base shadow-sm transition focus:outline-none ${completed
                                ? "cursor-not-allowed border-gray-200 bg-gray-50 text-gray-500 placeholder:text-gray-400"
                                : "border-gray-300 bg-white text-gray-700 placeholder:text-gray-400 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                              }`}
                          />
                        </div>
                      </div>

                      {/* Reserved 20% of the left half for help icons.
            Keeps all form boxes aligned at the same width. */}
                      <div aria-hidden="true" className="min-w-0" />
                    </div>
                  </div>

                  {/* Right Section: Service Information */}
                  {infoSectionOpen && (
                    <div className="min-w-0">
                      <ServiceInformation serviceName={infoSectionService} setInfoSectionOpen={setInfoSectionOpen} />
                    </div>
                  )}
                </div>

                {/* Complete Appointment */}
                {!completed && (
                  <div className="flex justify-end gap-3">
                    <button
                      type="button"
                      className="btn red !text-[16px]"
                      onClick={() => DNAClicked()}
                    >
                      Client DNA
                    </button>

                    <button
                      type="button"
                      className="btn warning !text-[16px]"
                      onClick={() => completeSessionClicked()}
                    >
                      Complete Appointment
                    </button>
                  </div>
                )}
              </div>
            )}

          </section>
        </section>
      )}
    </div>
  )
}

export default GpSession
